import React, { useEffect } from "react";
import { Box, Typography, Chip } from "@mui/material";
import { useDispatch } from "react-redux";
import video from "../assets/logo/DSC08236 1.svg";
import { AiOutlineEye } from "react-icons/ai";
import BaseSwiper from "../components/home/BaseSwiper";
import { setPageTitle } from "../slice";

function EducationAndAdvice() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle("آخرین مقاله"));
  }, [dispatch]);

  return (
    <Box display="flex" flexDirection="column" width="100%" alignItems="end">
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "column", md: "row" }}
        justifyContent="space-between"
        width="95%"
        bgcolor="#FAFAFA"
        borderRadius={6}
        p={{ xs: 1, md: 2 }}
        my={3}
      >
        <Box width={{ xs: "100%", sm: "100%", md: "47%" }} borderRadius={2}>
          <img src={video} alt="video" width="100%" />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          width={{ xs: "100%", sm: "95%", md: "50%" }}
          alignItems={"end"}
          position="relative"
        >
          <Chip
            label={"روانشناسی"}
            sx={{
              width: "auto",
              height: "25px",
              background: "rgba(246, 144, 90, 0.22)",
              color: "#F05662", // {color}
              mx: 1,
            }}
          />
          <Typography variant="h1" fontWeight={400} textAlign="right" my={2}>
            ازدواج و روزهای پیچیده
          </Typography>
          <Typography variant="h2" fontWeight={400} textAlign="right" mb={3}>
            جوانان مجرد متقاضی ازدواج را از ابتدای تصمیم‌گیری برای ازدواج تا 4 سال پس از ازدواج
            همراهی می‌کند
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            position="absolute"
            bottom="0"
          >
            <Box display="flex">
              <Typography fontSize="12px" color="#939393" mr={1}>
                ۱.۳۵۳ بازدید
              </Typography>
              <AiOutlineEye color="#939393" />
            </Box>
            <Typography fontSize="12px" color="#939393">
              نویسنده: آرش سام
            </Typography>
          </Box>
        </Box>
      </Box>
      <Typography variant="h1" textAlign="right" fontWeight={700} my={2}>
        :مطالب آموزشی{" "}
      </Typography>
      <BaseSwiper />
    </Box>
  );
}

export default EducationAndAdvice;
